import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecalculateButtonComponent } from './recalculate-button.component';
import { Trip2ThemeModule } from '../../../trip2-theme/trip2-theme.module';

@NgModule({
    imports: [
        CommonModule,
        Trip2ThemeModule
    ],
  declarations: [RecalculateButtonComponent],
  exports: [RecalculateButtonComponent]
})
export class RecalculateButtonModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/recalculate-button/recalculate-button.module.ts